(ns frontend.view.settings2.permissions.field-settings.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce fields (r/cursor db/app-state [:views :settings :field-settings]))
(defonce view-settings (r/cursor fields [:view-settings]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))
